/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit OnHoldStatusFliter/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import StatusTooltip from './StatusTooltip/index'
import TagStatusShortButton from 'DesignSystem/TagStatusShortButton/index'



/** @type {import('Simple/types.js').View} */
export default function OnHoldStatusFliter({
  children,
  viewPath = "/App/Account/Content/Comms/Topbar/FilterByStatus/OnHoldStatusFliter",
  onChange,
  isHovered
  
}) {
let tabSelectedStatusesValueData = fromData.useDataFormat({ viewPath,
context: 'tab',
path: 'selected.statuses',
format: fromFormat.isSelectedStatusOnHold,
})
let tabSelectedStatusesChangeData = fromData.useDataChange({ viewPath,
context: 'tab',
path: 'selected.statuses',
formatOut: fromFormat.toggleSelectedStatusOnHold,
})
  return (<React.Fragment
>
<TagStatusShortButton
  viewPath={`${viewPath}/TagStatusShortButton`}
 marginLeft={2}
 text="H"
 data="tab.selected.statuses"
 format="/Data/format.js isSelectedStatusOnHold"
 formatOut="/Data/format.js toggleSelectedStatusOnHold"
 isSelected={tabSelectedStatusesValueData}
 onClick={tabSelectedStatusesChangeData}
>
{childProps => (
<StatusTooltip
{...childProps}
  viewPath={`${viewPath}/StatusTooltip`}
 flowNo={!childProps.isHovered}
 flowContent={childProps.isHovered}
/>
)}
</TagStatusShortButton>
{children}
</React.Fragment>)
}